import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Chamomile Tea",
        price: 12.00,
        disprice: 9.99,
        stock: 10,
        content: "Relax and unwind with our calming Chamomile Tea, known for its delicate floral taste and natural soothing properties.",
        description: "Brewed from high-quality dried chamomile flowers, our Chamomile Tea is a caffeine-free infusion perfect for stress relief and better sleep. Enjoy it warm in the evening or anytime you need a moment of peace. Ideal for wellness lovers and tea connoisseurs alike.",
        category: ["Herbal Tea", "Relaxing Blend"],
        tags: ["herbal", "calming", "caffeine-free"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "100% Pure Chamomile Flowers" },
            { id: 2, title: "Serving Size", content: "1 Tea Bag per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Cool, Dry Place)" },
            { id: 4, title: "Benefits", content: "Promotes Relaxation & Better Sleep" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Carter",
                date: "July 10, 2025",
                rating: 5,
                content: "This tea is my go-to before bed. So calming and tastes amazing!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Brooks",
                date: "July 12, 2025",
                rating: 4.5,
                content: "Helps me relax after a long day. Light flavor but very soothing."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Peppermint Tea",
        price: 11.00,
        disprice: 8.49,
        stock: 6,
        content: "Invigorating and cool, our Peppermint Tea offers a refreshing burst of flavor and natural digestive benefits.",
        description: "Made from premium dried peppermint leaves, this caffeine-free tea delivers a crisp, minty flavor that awakens the senses and supports digestion. Enjoy it hot or iced as a revitalizing beverage any time of day.",
        category: ["Herbal Tea", "Wellness Drink"],
        tags: ["herbal", "mint", "caffeine-free"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "100% Pure Peppermint Leaves" },
            { id: 2, title: "Serving Size", content: "1 Tea Bag per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Cool, Dry Place)" },
            { id: 4, title: "Benefits", content: "Aids Digestion & Refreshes Breath" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Lena Morris",
                date: "July 15, 2025",
                rating: 5,
                content: "So refreshing and soothing! My favorite tea after meals."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Chris Allen",
                date: "July 17, 2025",
                rating: 4.5,
                content: "Love the cool, minty taste. Great for digestion too!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Ginger Tea",
        price: 13.00,
        disprice: 10.49,
        stock: 3,
        content: "Warming and spicy, Ginger Tea offers a natural boost to your immunity and digestion.",
        description: "Brewed from premium dried ginger root, our Ginger Tea delivers a bold, invigorating flavor with powerful health benefits. Ideal for relieving nausea, enhancing immunity, and keeping you warm during cold days. Naturally caffeine-free.",
        category: ["Wellness Drink", "Caffeine Free"],
        tags: ["ginger", "spicy", "caffeine-free"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "100% Dried Ginger Root" },
            { id: 2, title: "Serving Size", content: "1 Tea Bag per Cup" },
            { id: 3, title: "Shelf Life", content: "18 Months (Cool, Dry Place)" },
            { id: 4, title: "Benefits", content: "Supports Digestion & Immunity" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Aria Bennett",
                date: "July 18, 2025",
                rating: 5,
                content: "This tea is my go-to for colds and stomach aches. Very soothing!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Marcus Fields",
                date: "July 19, 2025",
                rating: 4.5,
                content: "Strong flavor, just how I like it. Works wonders after meals."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Hibiscus Tea",
        price: 14.00,
        disprice: 11.29,
        stock: 0,
        content: "Tangy and refreshing, Hibiscus Tea is rich in antioxidants and perfect served hot or cold.",
        description: "Our Hibiscus Tea is crafted from dried hibiscus petals, delivering a deep red color and a naturally tart flavor. A favorite for heart health, hydration, and antioxidant support, it’s caffeine-free and delicious as a warm brew or iced beverage.",
        category: ["Floral Infusion", "Caffeine Free"],
        tags: ["hibiscus", "floral", "antioxidant"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "100% Dried Hibiscus Petals" },
            { id: 2, title: "Serving Size", content: "1 Tea Bag per Cup" },
            { id: 3, title: "Shelf Life", content: "18 Months (Cool, Dry Place)" },
            { id: 4, title: "Benefits", content: "Rich in Antioxidants, Supports Heart Health" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Sophia Lane",
                date: "July 20, 2025",
                rating: 5,
                content: "Love the tart flavor! It’s so refreshing as iced tea in summer."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Liam Morgan",
                date: "July 21, 2025",
                rating: 4.5,
                content: "A beautiful color and great health benefits. I drink it daily!"
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Rooibos Tea",
        price: 15.00,
        disprice: 11.99,
        stock: 9,
        content: "Naturally sweet and caffeine-free, Rooibos Tea is perfect for relaxing and enjoying anytime of day.",
        description: "Rooibos Tea, also known as red bush tea, is a South African herbal infusion known for its earthy flavor and rich antioxidant content. It’s naturally caffeine-free, making it ideal for evenings or those seeking a calming, smooth tea experience.",
        category: ["Herbal Tea", "Caffeine Free"],
        tags: ["rooibos", "herbal", "calming"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Pure Rooibos Leaves" },
            { id: 2, title: "Serving Size", content: "1 Tea Bag per Cup" },
            { id: 3, title: "Shelf Life", content: "18 Months (Cool, Dry Place)" },
            { id: 4, title: "Benefits", content: "Supports Digestion, Promotes Relaxation" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Grace Nguyen",
                date: "July 22, 2025",
                rating: 5,
                content: "Mellow and soothing. I love it in the evening before bed."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Oliver Reed",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Great flavor and totally caffeine-free. A staple in my tea cabinet."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Sage Tea",
        price: 12.00,
        disprice: 9.59,
        stock: 5,
        content: "Aromatic and earthy, Sage Tea offers a soothing herbal brew with natural wellness benefits.",
        description: "Sage Tea is made from dried sage leaves, providing a warm, slightly peppery flavor. Traditionally used for its calming properties and digestive support, it's a perfect herbal infusion to enjoy throughout the day. Naturally caffeine-free and rich in antioxidants.",
        category: ["Herbal Tea", "Wellness Drink"],
        tags: ["sage", "herbal", "wellness"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Dried Sage Leaves" },
            { id: 2, title: "Serving Size", content: "1-2 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Sealed, Cool Storage)" },
            { id: 4, title: "Benefits", content: "Supports Digestion, Calms Nerves" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Isabella Moore",
                date: "July 22, 2025",
                rating: 5,
                content: "This tea has a lovely, calming aroma. I drink it every evening now."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "James Foster",
                date: "July 23, 2025",
                rating: 4,
                content: "Tastes earthy and fresh. Really helped with my digestion after meals."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Lemon Balm Tea",
        price: 13.00,
        disprice: 10.29,
        stock: 2,
        content: "A refreshing, citrus-scented herbal tea known for its calming and mood-lifting properties.",
        description: "Lemon Balm Tea is crafted from the leaves of the lemon balm plant, offering a light, lemony flavor with gentle mint undertones. Commonly used to reduce stress and promote restful sleep, this caffeine-free tea is a relaxing choice for day or night.",
        category: ["Relaxing Blend", "Wellness Drink"],
        tags: ["lemon", "herbal", "calm"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Organic Lemon Balm Leaves" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Cool, Dry Place)" },
            { id: 4, title: "Benefits", content: "Reduces Anxiety, Supports Sleep" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Chloe Anderson",
                date: "July 22, 2025",
                rating: 5,
                content: "Such a calming tea! It helps me wind down after a long day."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Liam Reynolds",
                date: "July 23, 2025",
                rating: 4.5,
                content: "I love the citrus-mint flavor. Really relaxing before bedtime."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Rose Hip Tea",
        price: 14.00,
        disprice: 11.39,
        stock: 0,
        content: "Tangy and vibrant, this herbal tea is packed with vitamin C and antioxidants for daily wellness.",
        description: "Rose Hip Tea is made from the fruit of the wild rose plant and offers a tart, fruity flavor with subtle floral notes. Naturally caffeine-free, it’s known to support immune health, reduce inflammation, and promote glowing skin. A perfect blend for a nourishing routine.",
        category: ["Floral Infusion", "Caffeine Free"],
        tags: ["rosehip", "vitaminC", "herbal"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Dried Rose Hips" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Airtight Storage)" },
            { id: 4, title: "Benefits", content: "Boosts Immunity, High in Antioxidants" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Sophie Martinez",
                date: "July 22, 2025",
                rating: 5,
                content: "A lovely fruity tea! I've made it part of my morning routine."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Ethan James",
                date: "July 23, 2025",
                rating: 4,
                content: "Strong tangy flavor and refreshing. Great iced too!"
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Passionflower Tea",
        price: 16.00,
        disprice: 12.49,
        stock: 9,
        content: "Calming herbal infusion known to reduce stress and support restful sleep naturally.",
        description: "Passionflower Tea is a gentle, naturally caffeine-free tea made from the dried petals of the passionflower plant. With mild earthy notes, it’s traditionally used to ease anxiety, improve sleep quality, and calm the mind after a long day. Perfect for evening relaxation or winding down.",
        category: ["Relaxing Blend", "Herbal Tea"],
        tags: ["calm", "herbal", "sleep"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Dried Passionflower Petals" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Sealed Container)" },
            { id: 4, title: "Benefits", content: "Stress Relief, Sleep Support, Anxiety Reduction" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Liam Parker",
                date: "July 22, 2025",
                rating: 5,
                content: "Truly calming—helps me fall asleep quicker and stay asleep longer."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Grace Nguyen",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Great taste and it does help me unwind after work."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Soothing Chamomile",
        price: 13.00,
        disprice: 10.19,
        stock: 10,
        content: "A gentle floral tea perfect for relaxing evenings and promoting restful sleep.",
        description: "Soothing Chamomile is a naturally caffeine-free tea made from carefully dried chamomile blossoms. Known for its calming properties, this tea is ideal before bedtime or during moments of stress. With a mild apple-like aroma and smooth flavor, it’s a favorite for wellness enthusiasts.",
        category: ["Relaxing Blend", "Herbal Tea"],
        tags: ["relax", "herbal", "calm"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Pure Chamomile Blossoms" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Airtight Container)" },
            { id: 4, title: "Benefits", content: "Promotes Sleep, Reduces Stress, Eases Digestion" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Sophia Martinez",
                date: "July 23, 2025",
                rating: 5,
                content: "This tea is part of my nightly routine—absolutely love how relaxing it is."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Ethan Wells",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Very smooth and soothing. Helps calm me after a long day."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Cool Peppermint",
        price: 12.00,
        disprice: 9.29,
        stock: 10,
        content: "A refreshing minty tea that awakens the senses and soothes digestion.",
        description: "Cool Peppermint tea is crafted from pure peppermint leaves, offering a clean, cooling flavor with a crisp finish. Naturally caffeine-free, it’s perfect after meals or as a revitalizing break throughout the day. Loved for its digestive benefits and calming aroma.",
        category: ["Wellness Drink", "Caffeine Free"],
        tags: ["mint", "herbal", "refresh"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "100% Peppermint Leaves" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Airtight Container)" },
            { id: 4, title: "Benefits", content: "Aids Digestion, Refreshes Breath, Calms Nausea" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Liam Foster",
                date: "July 23, 2025",
                rating: 5,
                content: "Super refreshing and helps a lot after heavy meals. My go-to tea!"
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Isla Bennett",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Great flavor and very cooling—love it iced too!"
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Spicy Ginger",
        price: 14.00,
        disprice: 11.49,
        stock: 10,
        content: "Bold and invigorating ginger tea that warms the body and boosts vitality.",
        description: "Spicy Ginger tea delivers a zesty punch made from premium dried ginger root. Known for its warming qualities and health benefits, it’s ideal for cold days or when you need a natural immune boost. Great on its own or with honey and lemon.",
        category: ["Caffeine Free", "Wellness Drink"],
        tags: ["ginger", "spice", "immunity"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "100% Dried Ginger Root" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Airtight Container)" },
            { id: 4, title: "Benefits", content: "Boosts Immunity, Eases Nausea, Aids Digestion" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Oliver Grant",
                date: "July 23, 2025",
                rating: 5,
                content: "Strong and spicy—just the way I like it! Helps with my digestion too."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Grace Morgan",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Perfect for winter mornings. I mix it with a bit of honey for extra warmth."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Floral Hibiscus",
        price: 15.00,
        disprice: 12.29,
        stock: 10,
        content: "A vibrant hibiscus tea with a tangy flavor and floral aroma that refreshes and revitalizes.",
        description: "Floral Hibiscus tea is a tart, ruby-red infusion crafted from dried hibiscus petals. Rich in antioxidants and known for supporting heart health, this tea can be enjoyed hot or cold. Naturally caffeine-free, it’s a delicious choice for any time of day.",
        category: ["Floral Infusion", "Herbal Tea"],
        tags: ["hibiscus", "floral", "refreshing"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Dried Hibiscus Petals" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Cool & Dry Place)" },
            { id: 4, title: "Benefits", content: "Supports Heart Health, Rich in Antioxidants, Caffeine-Free" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Maya Singh",
                date: "July 23, 2025",
                rating: 5,
                content: "Love the tangy kick and beautiful color! It’s my favorite iced tea now."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Liam Rivera",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Refreshing and flavorful. I feel great drinking it after meals."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Red Rooibos",
        price: 16.00,
        disprice: 12.59,
        stock: 10,
        content: "Naturally sweet and earthy, Red Rooibos is a caffeine-free tea perfect for calming your day.",
        description: "Red Rooibos tea is a naturally caffeine-free herbal infusion from South Africa, known for its rich, earthy flavor and soothing properties. Packed with antioxidants, it’s ideal for evening relaxation or a cozy afternoon break. Enjoy it hot or chilled, plain or with a splash of milk.",
        category: ["Herbal Tea", "Caffeine Free"],
        tags: ["rooibos", "earthy", "soothing"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Pure Rooibos Leaves" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "18 Months (Cool & Dry Place)" },
            { id: 4, title: "Benefits", content: "Rich in Antioxidants, Naturally Sweet, Supports Sleep" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sofia Bennett",
                date: "July 23, 2025",
                rating: 5,
                content: "So smooth and relaxing. My go-to tea before bedtime."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Oscar Green",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Love the flavor! I switched from regular tea and never looked back."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Herbal Sage",
        price: 13.00,
        disprice: 10.39,
        stock: 10,
        content: "Earthy and fragrant, Herbal Sage tea offers a refreshing taste and calming benefits in every sip.",
        description: "Herbal Sage tea is known for its distinct, savory aroma and natural wellness properties. Traditionally used for digestive support and mental clarity, this caffeine-free infusion is ideal for a relaxing moment or a mindful tea break. Enjoy it alone or blended with other herbs.",
        category: ["Wellness Drink", "Herbal Tea"],
        tags: ["sage", "herbal", "refreshing"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Dried Sage Leaves" },
            { id: 2, title: "Serving Size", content: "1 tsp per Cup" },
            { id: 3, title: "Shelf Life", content: "12 Months (Airtight Container)" },
            { id: 4, title: "Benefits", content: "Digestive Aid, Enhances Focus, Soothing Aroma" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Liam Foster",
                date: "July 23, 2025",
                rating: 4.5,
                content: "Strong herbal taste and very calming. I drink it in the evening."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Natalie Chen",
                date: "July 23, 2025",
                rating: 5,
                content: "Really helps with my digestion and the scent is very grounding."
            }
        ]
    }

];

export default products;